import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot } from '@angular/router';
import { Observable, combineLatest, of } from 'rxjs';
import { GroupStudentsScoreService } from '../services/group-students-score/group-students-score.service';
import { DEFAULT_LIST_VALUES } from '../assets/constants';
import { TableDatasource } from '@gamelearn/skeletor/models.js';
import { ConfigurationsService } from 'core/services';

export const GroupStudentsScoreResolver: ResolveFn<any> = (
  route?: ActivatedRouteSnapshot,
  state?: RouterStateSnapshot,
  groupStudentsService: GroupStudentsScoreService = inject(GroupStudentsScoreService),
  configurationsService: ConfigurationsService = inject(ConfigurationsService)
): Observable<any> => {
  const selectedGroup = route.parent?.data?.group || null;
  if (!selectedGroup) return of(null);

  return combineLatest([
    groupStudentsService.fetch$(DEFAULT_LIST_VALUES, TableDatasource, selectedGroup),
    configurationsService.getTooltipMessage$('groups.score')
  ]);
};
